import apiClient from '../api';

export const adminStudentsService = {
    getAll: (params: { page?: number; limit?: number; search?: string }) =>
        apiClient.get('/admin/students', { params }),

    getById: (id: string) =>
        apiClient.get(`/admin/students/${id}`),

    resetPassword: (id: string) =>
        apiClient.post(`/admin/students/${id}/reset-password`),

    generateCertificate: (id: string) =>
        apiClient.post(`/admin/students/${id}/generate-certificate`),

    resetLinkedInContent: (id: string) =>
        apiClient.delete(`/admin/students/${id}/linkedin-content`),
};
